import { reactive } from 'vue';

export const capabilityState = reactive({ value: null, updatedAt: 0 });

export function commitCapabilities(data, actorId) {
  const ids = values => Array.isArray(values) && values.length <= 4096 &&
    values.every(id => Number.isSafeInteger(id) && id > 0) && new Set(values).size === values.length;
  if (data?.schema !== 1 || data.actor_id !== actorId || typeof data.attention_enabled !== 'boolean' ||
      typeof data.native_enabled !== 'boolean' || !ids(data.account_ids) || !ids(data.legacy_account_ids) ||
      data.account_ids.some(id => data.legacy_account_ids.includes(id)) || (!data.attention_enabled && data.account_ids.length)) {
    throw Error('Invalid authenticated alert capability');
  }
  capabilityState.value = data;
  capabilityState.updatedAt = Date.now();
}

export function clearCapabilities() {
  capabilityState.value = null; capabilityState.updatedAt = 0;
}

export function accountAttentionEnabled(accountId) {
  const account = Number(accountId);
  if (!Number.isSafeInteger(account) || account <= 0) return false;
  if (capabilityState.value) return capabilityState.value.account_ids.includes(account);
  const config = window.chatwootConfig;
  if (config?.reliableAttention !== true) return false;
  // Bootstrap is only provisional; the authenticated control plane replaces
  // it. An explicit canary list never enables another account transiently.
  const selected = config.reliableAttentionAccountIds;
  return !Array.isArray(selected) || !selected.length || selected.includes(account);
}
